import { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

// -----------------------------------------------------------------------------

const WebexWebhookCoverImage = memo(function WebexWebhookCoverImage(props) {
  return (
    <SvgIcon viewBox="0 0 241.94 91.56" {...props}>
      <g>
        <g>
          <style>
            {
              ".cls-1{fill:url(#radial-gradient);}.cls-2{fill:url(#radial-gradient-2);}.cls-3{fill:url(#radial-gradient-3);}.cls-4{fill:url(#radial-gradient-4);}.cls-5{fill:url(#radial-gradient-5);}.cls-6{fill:url(#radial-gradient-6);}.cls-7{fill:url(#radial-gradient-7);}.cls-8{fill:url(#linear-gradient);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#radial-gradient-8);}.cls-14{fill:url(#radial-gradient-9);}.cls-15{fill:url(#radial-gradient-10);}.cls-16{fill:url(#radial-gradient-11);}.cls-17{fill:url(#radial-gradient-12);}.cls-18{fill:url(#radial-gradient-13);}.cls-19{fill:url(#radial-gradient-14);}.cls-20{fill:url(#radial-gradient-15);}.cls-21{fill:url(#radial-gradient-16);}.cls-22{fill:url(#radial-gradient-17);}.cls-23{fill:url(#radial-gradient-18);}.cls-24{fill:url(#radial-gradient-19);}.cls-25{fill:url(#radial-gradient-20);}.cls-26{fill:url(#radial-gradient-21);}.cls-27{fill:url(#linear-gradient-6);}.cls-28{fill:url(#radial-gradient-22);}.cls-29{fill:url(#radial-gradient-23);}.cls-30{fill:url(#radial-gradient-24);}.cls-31{fill:url(#radial-gradient-25);}.cls-32{fill:url(#radial-gradient-26);}.cls-33{fill:url(#radial-gradient-27);}.cls-34{fill:none;}.cls-35{clip-path:url(#clip-path);}.cls-36{clip-path:url(#clip-path-2);}.cls-37{clip-path:url(#clip-path-3);}.cls-38{fill:url(#linear-gradient-7);}.cls-39{mask:url(#mask);}.cls-40{fill:url(#radial-gradient-28);}.cls-41{mask:url(#mask-2);}.cls-42{fill:url(#radial-gradient-29);}.cls-43{mask:url(#mask-3);}.cls-44{fill:url(#radial-gradient-30);}.cls-45{fill:url(#radial-gradient-31);}.cls-46{fill:url(#radial-gradient-32);}.cls-47{mask:url(#mask-6);}.cls-48{fill:url(#radial-gradient-33);}.cls-49{mask:url(#mask-7);}.cls-50{fill:url(#radial-gradient-34);}.cls-51{mask:url(#mask-8);}.cls-52{fill:url(#radial-gradient-35);}.cls-53{mask:url(#mask-9);}.cls-54{fill:url(#radial-gradient-36);}.cls-55{mask:url(#mask-10);}.cls-56{fill:url(#radial-gradient-37);}.cls-57{mask:url(#mask-11);}.cls-58{fill:url(#radial-gradient-38);}.cls-59{mask:url(#mask-12);}.cls-60{fill:url(#radial-gradient-39);}.cls-61{mask:url(#mask-13);}.cls-62{fill:url(#radial-gradient-40);}.cls-63{mask:url(#mask-14);}.cls-64{fill:url(#radial-gradient-41);}.cls-65{mask:url(#mask-15);}.cls-66{fill:url(#radial-gradient-42);}.cls-67{mask:url(#mask-16);}.cls-68{fill:url(#linear-gradient-8);}.cls-69{mask:url(#mask-17);}.cls-70{fill:url(#linear-gradient-9);}.cls-71{mask:url(#mask-18);}.cls-72{fill:url(#linear-gradient-10);}.cls-73{mask:url(#mask-19);}.cls-74{fill:url(#linear-gradient-11);}.cls-75{clip-path:url(#clip-path-23);}.cls-76{mask:url(#mask-20);}.cls-77{fill:url(#linear-gradient-12);}.cls-78{clip-path:url(#clip-path-24);}.cls-79{fill:url(#linear-gradient-13);}.cls-80{mask:url(#mask-21);}.cls-81{fill:url(#radial-gradient-43);}.cls-82{mask:url(#mask-22);}.cls-83{fill:url(#radial-gradient-44);}.cls-84{mask:url(#mask-23);}.cls-85{fill:url(#radial-gradient-45);}.cls-86{mask:url(#mask-24);}.cls-87{fill:url(#radial-gradient-46);}.cls-88{mask:url(#mask-25);}.cls-89{fill:url(#radial-gradient-47);}.cls-90{fill:url(#radial-gradient-48);}.cls-91{fill:url(#radial-gradient-49);}.cls-92{mask:url(#mask-28);}.cls-93{fill:url(#radial-gradient-50);}.cls-94{mask:url(#mask-29);}.cls-95{fill:url(#radial-gradient-51);}.cls-96{fill:url(#radial-gradient-52);}.cls-97{mask:url(#mask-31);}.cls-98{fill:url(#radial-gradient-53);}.cls-99{mask:url(#mask-32);}.cls-100{fill:url(#radial-gradient-54);}.cls-101{mask:url(#mask-33);}.cls-102{fill:url(#linear-gradient-14);}"
            }
          </style>
          <radialGradient
            id="radial-gradient"
            cx={244.32}
            cy={424.96}
            r={0.79}
            gradientTransform="matrix(0, 26.2, 19.91, 0, -8157, -6029.81)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.14} stopColor="#cfcfcf" />
            <stop offset={0.58} stopColor="#3b3b3b" />
            <stop offset={0.78} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-2"
            cx={244.16}
            cy={425.47}
            r={0.79}
            gradientTransform="matrix(-17.72, 0, 0, 13.46, 4629.8, -5346.55)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.25} stopColor="#b3b3b3" />
            <stop offset={0.71} stopColor="#333" />
            <stop offset={0.92} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-3"
            cx={244.69}
            cy={423.4}
            r={0.79}
            gradientTransform="matrix(25.66, 0, 0, -20.27, -5980.02, 8960.49)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.05} stopColor="#fff" />
            <stop offset={0.11} stopColor="#ccc" />
            <stop offset={0.21} stopColor="#858585" />
            <stop offset={0.32} stopColor="#4a4a4a" />
            <stop offset={0.42} stopColor="#212121" />
            <stop offset={0.51} stopColor="#080808" />
            <stop offset={0.6} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-4"
            cx={242.99}
            cy={422.63}
            r={0.79}
            gradientTransform="matrix(0, -15.29, -12.04, 0, 5383.18, 4089.2)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.26} stopColor="#fff" />
            <stop offset={0.27} stopColor="#fafafa" />
            <stop offset={0.38} stopColor="#adadad" />
            <stop offset={0.5} stopColor="#6e6e6e" />
            <stop offset={0.62} stopColor="#3d3d3d" />
            <stop offset={0.74} stopColor="#1c1c1c" />
            <stop offset={0.86} stopColor="#080808" />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-5"
            cx={242.38}
            cy={423.81}
            r={0.79}
            gradientTransform="matrix(0, -14.34, -14.34, 0, 6369.64, 3845.11)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.11} stopColor="#bababa" />
            <stop offset={0.27} stopColor="#696969" />
            <stop offset={0.42} stopColor="#2e2e2e" />
            <stop offset={0.55} stopColor="#0d0d0d" />
            <stop offset={0.66} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-6"
            cx={242.89}
            cy={421.55}
            r={0.79}
            gradientTransform="matrix(0, -10.03, -8.42, 0, 3841.54, 2813.88)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.13} stopColor="#fff" />
            <stop offset={0.24} stopColor="#c9c9c9" />
            <stop offset={0.45} stopColor="#737373" />
            <stop offset={0.65} stopColor="#333" />
            <stop offset={0.82} stopColor="#0d0d0d" />
            <stop offset={0.95} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-7"
            cx={245.36}
            cy={421.3}
            r={0.79}
            gradientTransform="matrix(9.43, 0, 0, -7.47, -2023.86, 3518.93)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.1} stopColor="#dedede" />
            <stop offset={0.41} stopColor="gray" />
            <stop offset={0.67} stopColor="#3b3b3b" />
            <stop offset={0.88} stopColor="#0f0f0f" />
            <stop offset={1} />
          </radialGradient>
          <linearGradient
            id="linear-gradient"
            x1={244.77}
            y1={424.36}
            x2={245.56}
            y2={424.36}
            gradientTransform="matrix(0, 32.96, 32.96, 0, -13686.8, -7722.9)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.13} stopColor="#fff" />
            <stop offset={0.27} stopColor="#a3a3a3" />
            <stop offset={0.4} stopColor="#4d4d4d" />
            <stop offset={0.49} stopColor="#141414" />
            <stop offset={0.54} />
            <stop offset={1} />
          </linearGradient>
          <linearGradient
            id="linear-gradient-2"
            x1={245}
            y1={423.69}
            x2={245.79}
            y2={423.69}
            gradientTransform="matrix(29.37, 0, 0, -29.37, -6928.33, 12815.74)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.06} stopColor="#e0e0e0" />
            <stop offset={0.24} stopColor="#828282" />
            <stop offset={0.39} stopColor="#3b3b3b" />
            <stop offset={0.5} stopColor="#0f0f0f" />
            <stop offset={0.55} />
            <stop offset={1} />
          </linearGradient>
          <linearGradient
            id="linear-gradient-3"
            x1={244.81}
            y1={423.66}
            x2={245.59}
            y2={423.66}
            gradientTransform="matrix(33.8, 0, 0, -33.8, -8002.57, 14694.08)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.04} stopColor="#e0e0e0" />
            <stop offset={0.17} stopColor="#828282" />
            <stop offset={0.27} stopColor="#3b3b3b" />
            <stop offset={0.34} stopColor="#0f0f0f" />
            <stop offset={0.38} />
            <stop offset={1} />
          </linearGradient>
          <linearGradient
            id="linear-gradient-4"
            x1={244.43}
            y1={424.46}
            x2={245.22}
            y2={424.46}
            gradientTransform="matrix(0, 34.07, 34.07, 0, -14163.93, -7961.17)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} />
            <stop offset={0.62} />
            <stop offset={0.66} stopColor="#0f0f0f" />
            <stop offset={0.73} stopColor="#3b3b3b" />
            <stop offset={0.83} stopColor="#828282" />
            <stop offset={0.96} stopColor="#e0e0e0" />
            <stop offset={1} stopColor="#fff" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-5"
            x1={243.66}
            y1={422.74}
            x2={244.44}
            y2={422.74}
            gradientTransform="matrix(0, -13.95, -13.95, 0, 6207.33, 3774.7)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.11} stopColor="#ccc" />
            <stop offset={0.27} stopColor="#858585" />
            <stop offset={0.43} stopColor="#4a4a4a" />
            <stop offset={0.58} stopColor="#212121" />
            <stop offset={0.7} stopColor="#080808" />
            <stop offset={0.8} />
            <stop offset={1} />
          </linearGradient>
          <radialGradient
            id="radial-gradient-8"
            cx={244.22}
            cy={425.69}
            r={0.79}
            gradientTransform="matrix(0, 16.52, 11.73, 0, -4684.87, -3664.22)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.07} stopColor="#e6e6e6" />
            <stop offset={0.34} stopColor="#828282" />
            <stop offset={0.59} stopColor="#3b3b3b" />
            <stop offset={0.79} stopColor="#0f0f0f" />
            <stop offset={0.92} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-9"
            cx={243.99}
            cy={424.86}
            r={0.79}
            gradientTransform="matrix(-31.53, 0, 0, 20.81, 7999.93, -8457.64)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.4} stopColor="#6b6b6b" />
            <stop offset={0.7} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-10"
            cx={246.84}
            cy={422.85}
            r={0.79}
            gradientTransform="matrix(-3878.79, -0.02, -0.01, 2091.41, 998595, -874956.97)"
            xlinkHref="#radial-gradient-9"
          />
          <radialGradient
            id="radial-gradient-11"
            cx={246.41}
            cy={423}
            r={0.79}
            gradientTransform="matrix(-4619.43, -0.07, -0.03, 1908.39, 1179713.6, -799705.27)"
            xlinkHref="#radial-gradient-9"
          />
          <radialGradient
            id="radial-gradient-12"
            cx={244.17}
            cy={424.94}
            r={0.79}
            gradientTransform="matrix(0, 27.56, 19.23, 0, -7859.39, -6357.41)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.16} stopColor="#b0b0b0" />
            <stop offset={0.33} stopColor="#666" />
            <stop offset={0.49} stopColor="#2e2e2e" />
            <stop offset={0.61} stopColor="#0d0d0d" />
            <stop offset={0.7} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-13"
            cx={244.23}
            cy={424.91}
            r={0.79}
            gradientTransform="matrix(0, 26.49, 18.01, 0, -7337.8, -6091.47)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.37} stopColor="#737373" />
            <stop offset={0.7} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-14"
            cx={244.4}
            cy={425.48}
            r={0.79}
            gradientTransform="matrix(0, 12.31, 11.7, 0, -4666.18, -2627.61)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.09} stopColor="#c7c7c7" />
            <stop offset={0.22} stopColor="gray" />
            <stop offset={0.35} stopColor="#474747" />
            <stop offset={0.47} stopColor="#212121" />
            <stop offset={0.59} stopColor="#080808" />
            <stop offset={0.7} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-15"
            cx={244.36}
            cy={425.49}
            r={0.79}
            gradientTransform="matrix(0, 12.31, 11.7, 0, -4666.45, -2625.5)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ccc" />
            <stop offset={0.01} stopColor="#c7c7c7" />
            <stop offset={0.24} stopColor="#737373" />
            <stop offset={0.44} stopColor="#333" />
            <stop offset={0.6} stopColor="#0d0d0d" />
            <stop offset={0.7} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-16"
            cx={244.37}
            cy={425.13}
            r={0.79}
            gradientTransform="matrix(0, 29.39, 19.5, 0, -8000.95, -6811.84)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.4} stopColor="#8f8f8f" />
            <stop offset={0.48} stopColor="#6e6e6e" />
            <stop offset={0.69} stopColor="#1f1f1f" />
            <stop offset={0.79} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-17"
            cx={244.39}
            cy={425.63}
            r={0.79}
            gradientTransform="matrix(0, 21.8, 14.39, 0, -5835.87, -4960.87)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.06} stopColor="#e0e0e0" />
            <stop offset={0.21} stopColor="#9c9c9c" />
            <stop offset={0.36} stopColor="#636363" />
            <stop offset={0.51} stopColor="#383838" />
            <stop offset={0.67} stopColor="#1a1a1a" />
            <stop offset={0.83} stopColor="#050505" />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-18"
            cx={244.39}
            cy={425.63}
            r={0.79}
            gradientTransform="matrix(0, 21.8, 14.39, 0, -5835.87, -4960.87)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.06} stopColor="#dedede" />
            <stop offset={0.21} stopColor="#9c9c9c" />
            <stop offset={0.36} stopColor="#636363" />
            <stop offset={0.52} stopColor="#383838" />
            <stop offset={0.67} stopColor="#1a1a1a" />
            <stop offset={0.83} stopColor="#050505" />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-19"
            cx={244.28}
            cy={426.09}
            r={0.79}
            gradientTransform="matrix(0, 13.34, 9.47, 0, -3727.18, -2888.94)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.36} stopColor="#a1a1a1" />
            <stop offset={0.92} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-20"
            cx={244.54}
            cy={426.11}
            r={0.79}
            gradientTransform="matrix(0, 16.68, 11.01, 0, -4400.88, -3713.01)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.03} stopColor="#f2f2f2" />
            <stop offset={0.18} stopColor="#a8a8a8" />
            <stop offset={0.34} stopColor="#6b6b6b" />
            <stop offset={0.5} stopColor="#3d3d3d" />
            <stop offset={0.66} stopColor="#1a1a1a" />
            <stop offset={0.82} stopColor="#080808" />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-21"
            cx={244.3}
            cy={426.06}
            r={0.79}
            gradientTransform="matrix(0, 13.18, 11.6, 0, -4651.02, -2850.12)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#999" />
            <stop offset={0.04} stopColor="#999" />
            <stop offset={0.2} stopColor="#7d7d7d" />
            <stop offset={0.52} stopColor="#333" />
            <stop offset={0.73} />
            <stop offset={1} />
          </radialGradient>
          <linearGradient
            id="linear-gradient-6"
            x1={244.04}
            y1={424.59}
            x2={244.83}
            y2={424.59}
            gradientTransform="matrix(-39.71, 0, 0, 39.71, 10023.18, -16486.77)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.05} stopColor="#e8e8e8" />
            <stop offset={0.16} stopColor="#a8a8a8" />
            <stop offset={0.32} stopColor="#474747" />
            <stop offset={0.43} />
            <stop offset={1} />
          </linearGradient>
          <radialGradient
            id="radial-gradient-22"
            cx={244.33}
            cy={426.88}
            r={0.79}
            gradientTransform="matrix(0, 10.64, 6.81, 0, -2598.28, -2229.49)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.15} stopColor="#ededed" />
            <stop offset={0.38} stopColor="#bdbdbd" />
            <stop offset={0.67} stopColor="#6e6e6e" />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-23"
            cx={245.1}
            cy={424.42}
            r={0.79}
            gradientTransform="matrix(0, 17.11, 12.84, 0, -5142.34, -3813.95)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.36} stopColor="#8f8f8f" />
            <stop offset={0.72} stopColor="#292929" />
            <stop offset={0.9} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-24"
            cx={244.96}
            cy={424.23}
            r={0.79}
            gradientTransform="matrix(0, 22.82, 20.87, 0, -8531.58, -5228.03)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.07} stopColor="#e6e6e6" />
            <stop offset={0.41} stopColor="#6b6b6b" />
            <stop offset={0.65} stopColor="#1f1f1f" />
            <stop offset={0.76} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-25"
            cx={247.15}
            cy={422.52}
            r={0.79}
            gradientTransform="matrix(-0.09, 4054.98, 2845.58, 0.06, -1186303.74, -1049056.68)"
            xlinkHref="#radial-gradient-24"
          />
          <radialGradient
            id="radial-gradient-26"
            cx={243.91}
            cy={424.75}
            r={0.79}
            gradientTransform="matrix(-20.13, 0, 0, 24.88, 5210.66, -10180.56)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ccc" />
            <stop offset={0.06} stopColor="#a6a6a6" />
            <stop offset={0.21} stopColor="#5e5e5e" />
            <stop offset={0.35} stopColor="#2b2b2b" />
            <stop offset={0.47} stopColor="#0a0a0a" />
            <stop offset={0.56} />
            <stop offset={1} />
          </radialGradient>
          <radialGradient
            id="radial-gradient-27"
            cx={244.46}
            cy={423.39}
            r={0.79}
            gradientTransform="matrix(26.3, 0, 0, -28.41, -6130.32, 12404.62)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={0.04} stopColor="#ededed" />
            <stop offset={0.33} stopColor="#6e6e6e" />
            <stop offset={0.54} stopColor="#1f1f1f" />
            <stop offset={0.65} />
            <stop offset={1} />
          </radialGradient>
          <clipPath id="clip-path" transform="translate(-253.06 -327.51)">
            <rect
              className="cls-34"
              x={273}
              y={353.3}
              width={222}
              height={61.4}
            />
          </clipPath>
          <clipPath id="clip-path-2" transform="translate(-253.06 -327.51)">
            <rect
              className="cls-34"
              x={273}
              y={353.3}
              width={222}
              height={61.09}
            />
          </clipPath>
          <clipPath id="clip-path-3" transform="translate(-253.06 -327.51)">
            <path
              className="cls-34"
              d="M310.71,353.3a11.08,11.08,0,0,0-5.51,1.41,12.58,12.58,0,0,0-4.41,3.7l-5.59,15a14.73,14.73,0,0,1-.39,1.66c-.08.31-.16.55-.24.86a44.33,44.33,0,0,1-1.65,4.57c-.48.86-1.18,1.89-2.44,1.65l-.48-.24a5.78,5.78,0,0,1-1.81-2.28,30.38,30.38,0,0,1-2.52-6.22,49.11,49.11,0,0,1-1.65-8.26,7.15,7.15,0,0,0-1-3.62,5.42,5.42,0,0,0-1.58-1.42,5.55,5.55,0,0,0-2.67-.79,6.33,6.33,0,0,0-2.92.63,5.1,5.1,0,0,0-2,2,4.87,4.87,0,0,0-.79,2.75,5.5,5.5,0,0,0,.16,1.1c.31,3.15,1.65,12.92,6.14,20.32,0,0,3.7,7.16,11.65,7a13.46,13.46,0,0,0,5.51-1.34,11.94,11.94,0,0,0,4.41-3.54l3.23-7.16,2.36-7.56.23-1.18a36.43,36.43,0,0,1,1.89-5.83,4.38,4.38,0,0,1,1.34-2l.08-.08a1.57,1.57,0,0,1,1.73.23,2.3,2.3,0,0,1,.71.79c.24.31.39.63.63.94a15.23,15.23,0,0,1,1,2A10.46,10.46,0,0,0,315,370a.08.08,0,0,1,.08.08,6.49,6.49,0,0,0,1.89,1.41,4.57,4.57,0,0,0,2.28.55,6.29,6.29,0,0,0,2.13-.39,5,5,0,0,0,1.81-1.18,9.22,9.22,0,0,0,1.18-1.81,7,7,0,0,0,.39-2.13,5.74,5.74,0,0,0-.47-2.28s-2.13-5.51-5.83-8.27A12.57,12.57,0,0,0,310.71,353.3Z"
            />
          </clipPath>
          <linearGradient
            id="linear-gradient-7"
            x1={244.44}
            y1={423.78}
            x2={245.23}
            y2={423.78}
            gradientTransform="matrix(59.13, 0, 0, -59.13, -14179.1, 25431)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#1cbbf3" />
            <stop offset={0.13} stopColor="#1cbbf3" />
            <stop offset={0.34} stopColor="#1f99a5" />
            <stop offset={0.45} stopColor="#209ca6" />
            <stop offset={0.51} stopColor="#24a4aa" />
            <stop offset={0.57} stopColor="#2bb3b0" />
            <stop offset={0.6} stopColor="#30bdb4" />
            <stop offset={0.79} stopColor="#38ba90" />
            <stop offset={1} stopColor="#60f05a" />
          </linearGradient>
          <mask
            id="mask"
            x={9.53}
            y={12.32}
            width={72.53}
            height={66.91}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-1"
                x={268.56}
                y={347.05}
                width={60.6}
                height={52.48}
                transform="translate(-89.77 94.66) rotate(-15.68)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-28"
            cx={244.32}
            cy={424.96}
            r={0.79}
            gradientTransform="matrix(0, 26.2, 19.91, 0, -8157, -6029.81)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#227b60" />
            <stop offset={0.14} stopColor="#227b60" />
            <stop offset={0.58} stopColor="#227b60" />
            <stop offset={0.78} stopColor="#227b60" />
            <stop offset={1} stopColor="#227b60" />
          </radialGradient>
          <mask
            id="mask-2"
            x={19.14}
            y={24.75}
            width={53.32}
            height={42.06}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-2"
                x={278.35}
                y={347.04}
                width={41.02}
                height={52.51}
                transform="translate(-80.33 664.63) rotate(-88.85)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-29"
            cx={244.16}
            cy={425.47}
            r={0.79}
            gradientTransform="matrix(-17.72, 0, 0, 13.46, 4629.8, -5346.55)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#227b60" />
            <stop offset={0.25} stopColor="#227b60" />
            <stop offset={0.71} stopColor="#227b60" />
            <stop offset={0.92} stopColor="#227b60" />
            <stop offset={1} stopColor="#227b60" />
          </radialGradient>
          <mask
            id="mask-3"
            x={18.96}
            y={24.52}
            width={53.67}
            height={42.52}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-13"
                x={272.52}
                y={352.67}
                width={52.68}
                height={41.24}
                transform="translate(-9.03 7.41) rotate(-1.4)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-30"
            cx={244.22}
            cy={425.69}
            r={0.79}
            gradientTransform="matrix(0, 16.52, 11.73, 0, -4684.87, -3664.22)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#227b60" />
            <stop offset={0.07} stopColor="#227b60" />
            <stop offset={0.34} stopColor="#227b60" />
            <stop offset={0.59} stopColor="#227b60" />
            <stop offset={0.79} stopColor="#227b60" />
            <stop offset={0.92} stopColor="#227b60" />
            <stop offset={1} stopColor="#227b60" />
          </radialGradient>
          <radialGradient
            id="radial-gradient-31"
            cx={244.28}
            cy={426.09}
            r={0.79}
            gradientTransform="matrix(0, 13.34, 9.47, 0, -3727.18, -2888.94)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#227b60" />
            <stop offset={0.36} stopColor="#227b60" />
            <stop offset={0.92} stopColor="#227b60" />
            <stop offset={1} stopColor="#227b60" />
          </radialGradient>
          <radialGradient
            id="radial-gradient-32"
            cx={244.33}
            cy={426.88}
            r={0.79}
            gradientTransform="matrix(0, 10.64, 6.81, 0, -2598.28, -2229.49)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#20735a" />
            <stop offset={0.15} stopColor="#20745a" />
            <stop offset={0.38} stopColor="#21755c" />
            <stop offset={0.67} stopColor="#21785d" />
            <stop offset={1} stopColor="#227b60" />
          </radialGradient>
          <mask
            id="mask-6"
            x={5.17}
            y={6.69}
            width={81.25}
            height={78.19}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-29"
                x={270.13}
                y={341.56}
                width={57.46}
                height={63.46}
                transform="translate(-163.29 496.1) rotate(-66.2)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-33"
            cx={245.1}
            cy={424.42}
            r={0.79}
            gradientTransform="matrix(0, 17.11, 12.84, 0, -5142.34, -3813.95)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#227a61" />
            <stop offset={0.36} stopColor="#227a61" />
            <stop offset={0.72} stopColor="#227a61" />
            <stop offset={0.9} stopColor="#227a61" />
            <stop offset={1} stopColor="#227a61" />
          </radialGradient>
          <mask
            id="mask-7"
            x={1.08}
            y={1.4}
            width={89.43}
            height={88.76}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-30"
                x={267.6}
                y={340.63}
                width={62.52}
                height={65.32}
                transform="translate(-178.48 401.72) rotate(-54.73)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-34"
            cx={244.96}
            cy={424.23}
            r={0.79}
            gradientTransform="matrix(0, 22.82, 20.87, 0, -8531.58, -5228.03)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#3cd9c3" />
            <stop offset={0.07} stopColor="#3bd7c1" />
            <stop offset={0.41} stopColor="#38ceb9" />
            <stop offset={0.65} stopColor="#36c8b4" />
            <stop offset={0.76} stopColor="#35c6b2" />
            <stop offset={1} stopColor="#35c6b2" />
          </radialGradient>
          <mask
            id="mask-8"
            x={1.08}
            y={1.4}
            width={89.43}
            height={88.75}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-31"
                x={267.6}
                y={340.64}
                width={62.52}
                height={65.32}
                transform="translate(-178.48 401.74) rotate(-54.73)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-35"
            cx={247.15}
            cy={422.52}
            r={0.79}
            gradientTransform="matrix(-0.09, 4054.98, 2845.58, 0.06, -1186303.74, -1049056.68)"
            xlinkHref="#radial-gradient-34"
          />
          <mask
            id="mask-9"
            x={12.46}
            y={16.12}
            width={66.67}
            height={59.32}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-32"
                x={274.31}
                y={344.1}
                width={49.1}
                height={58.39}
                transform="translate(-124.49 595.64) rotate(-79.03)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-36"
            cx={243.91}
            cy={424.75}
            r={0.79}
            gradientTransform="matrix(-20.13, 0, 0, 24.88, 5210.66, -10180.56)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#237f66" />
            <stop offset={0.06} stopColor="#2c8c70" />
            <stop offset={0.21} stopColor="#3da785" />
            <stop offset={0.35} stopColor="#4aba93" />
            <stop offset={0.47} stopColor="#51c59c" />
            <stop offset={0.56} stopColor="#54c99f" />
            <stop offset={1} stopColor="#54c99f" />
          </radialGradient>
          <mask
            id="mask-10"
            x={0.35}
            y={0.45}
            width={90.89}
            height={90.65}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-33"
                x={267.02}
                y={340.61}
                width={63.68}
                height={65.36}
                transform="translate(-179.31 369.13) rotate(-50.82)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-37"
            cx={244.46}
            cy={423.39}
            r={0.79}
            gradientTransform="matrix(26.3, 0, 0, -28.41, -6130.32, 12404.62)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#167c8a" />
            <stop offset={0.04} stopColor="#167c8a" />
            <stop offset={0.33} stopColor="#177f8d" />
            <stop offset={0.54} stopColor="#17818f" />
            <stop offset={0.65} stopColor="#178290" />
            <stop offset={1} stopColor="#178290" />
          </radialGradient>
          <mask
            id="mask-11"
            x={2.07}
            y={2.68}
            width={87.45}
            height={86.21}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-3"
                x={266.35}
                y={342.7}
                width={65.01}
                height={61.19}
                transform="translate(-151.46 212.42) rotate(-31.66)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-38"
            cx={244.69}
            cy={423.4}
            r={0.79}
            gradientTransform="matrix(25.66, 0, 0, -20.27, -5980.02, 8960.49)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#177d87" />
            <stop offset={0.05} stopColor="#177d87" />
            <stop offset={0.11} stopColor="#177e89" />
            <stop offset={0.21} stopColor="#177f8b" />
            <stop offset={0.32} stopColor="#17818d" />
            <stop offset={0.42} stopColor="#17818f" />
            <stop offset={0.51} stopColor="#178290" />
            <stop offset={0.6} stopColor="#178290" />
            <stop offset={1} stopColor="#178290" />
          </radialGradient>
          <mask
            id="mask-12"
            x={0.18}
            y={0.24}
            width={91.23}
            height={91.09}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-4"
                x={266.21}
                y={341.29}
                width={65.3}
                height={64.01}
                transform="translate(-170.89 283.85) rotate(-40.54)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-39"
            cx={242.99}
            cy={422.63}
            r={0.79}
            gradientTransform="matrix(0, -15.29, -12.04, 0, 5383.18, 4089.2)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#177f8a" />
            <stop offset={0.26} stopColor="#177f8a" />
            <stop offset={0.27} stopColor="#177f8a" />
            <stop offset={0.38} stopColor="#17808c" />
            <stop offset={0.5} stopColor="#17818d" />
            <stop offset={0.62} stopColor="#17818f" />
            <stop offset={0.74} stopColor="#17828f" />
            <stop offset={0.86} stopColor="#178290" />
            <stop offset={1} stopColor="#178290" />
          </radialGradient>
          <mask
            id="mask-13"
            x={15.17}
            y={19.62}
            width={61.25}
            height={52.31}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-5"
                x={275.91}
                y={345.22}
                width={45.91}
                height={56.15}
                transform="translate(-107.59 625.21) rotate(-83.11)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-40"
            cx={242.38}
            cy={423.81}
            r={0.79}
            gradientTransform="matrix(0, -14.34, -14.34, 0, 6369.64, 3845.11)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#13656e" />
            <stop offset={0.11} stopColor="#13646e" />
            <stop offset={0.27} stopColor="#12646e" />
            <stop offset={0.42} stopColor="#12636e" />
            <stop offset={0.55} stopColor="#12636e" />
            <stop offset={0.66} stopColor="#12636e" />
            <stop offset={1} stopColor="#12636e" />
          </radialGradient>
          <mask
            id="mask-14"
            x={2.86}
            y={3.7}
            width={85.87}
            height={84.16}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-6"
                x={266.52}
                y={343.2}
                width={64.68}
                height={60.2}
                transform="translate(-144.51 194.17) rotate(-29.32)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-41"
            cx={242.89}
            cy={421.55}
            r={0.79}
            gradientTransform="matrix(0, -10.03, -8.42, 0, 3841.54, 2813.88)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#146a73" />
            <stop offset={0.13} stopColor="#146a73" />
            <stop offset={0.24} stopColor="#156f79" />
            <stop offset={0.45} stopColor="#167783" />
            <stop offset={0.65} stopColor="#167d8a" />
            <stop offset={0.82} stopColor="#17818e" />
            <stop offset={0.95} stopColor="#178290" />
            <stop offset={1} stopColor="#178290" />
          </radialGradient>
          <mask
            id="mask-15"
            x={1.39}
            y={1.8}
            width={88.8}
            height={87.95}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-7"
                x={267.82}
                y={340.67}
                width={62.08}
                height={65.24}
                transform="translate(-177.74 412.25) rotate(-55.99)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-42"
            cx={245.36}
            cy={421.3}
            r={0.79}
            gradientTransform="matrix(9.43, 0, 0, -7.47, -2023.86, 3518.93)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#198e9c" />
            <stop offset={0.1} stopColor="#198e9c" />
            <stop offset={0.41} stopColor="#198e9c" />
            <stop offset={0.67} stopColor="#198e9c" />
            <stop offset={0.88} stopColor="#198e9c" />
            <stop offset={1} stopColor="#198e9c" />
          </radialGradient>
          <mask
            id="mask-16"
            x={0}
            y={0}
            width={91.59}
            height={91.56}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-8"
                x={266.62}
                y={340.73}
                width={64.48}
                height={65.12}
                transform="translate(-178.11 339.1) rotate(-47.22)"
              />
            </g>
          </mask>
          <linearGradient
            id="linear-gradient-8"
            x1={244.77}
            y1={424.36}
            x2={245.56}
            y2={424.36}
            gradientTransform="matrix(0, 32.96, 32.96, 0, -13686.8, -7722.9)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#2bf9ff" />
            <stop offset={0.13} stopColor="#2bf9ff" />
            <stop offset={0.27} stopColor="#29f9ff" />
            <stop offset={0.4} stopColor="#27faff" />
            <stop offset={0.49} stopColor="#26faff" />
            <stop offset={0.54} stopColor="#26faff" />
            <stop offset={1} stopColor="#26faff" />
          </linearGradient>
          <mask
            id="mask-17"
            x={9.44}
            y={12.21}
            width={72.71}
            height={67.14}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-9"
                x={268.53}
                y={347}
                width={60.67}
                height={52.58}
                transform="translate(-90.49 95.67) rotate(-15.83)"
              />
            </g>
          </mask>
          <linearGradient
            id="linear-gradient-9"
            x1={245}
            y1={423.69}
            x2={245.79}
            y2={423.69}
            gradientTransform="matrix(29.37, 0, 0, -29.37, -6928.33, 12815.74)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#26faff" />
            <stop offset={0.06} stopColor="#26faff" />
            <stop offset={0.24} stopColor="#26faff" />
            <stop offset={0.39} stopColor="#26faff" />
            <stop offset={0.5} stopColor="#26faff" />
            <stop offset={0.55} stopColor="#26faff" />
            <stop offset={1} stopColor="#26faff" />
          </linearGradient>
          <mask
            id="mask-18"
            x={7.29}
            y={9.43}
            width={77.02}
            height={72.71}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-10"
                x={267.79}
                y={345.78}
                width={62.15}
                height={55.04}
                transform="translate(-107.99 122.01) rotate(-19.62)"
              />
            </g>
          </mask>
          <linearGradient
            id="linear-gradient-10"
            x1={244.81}
            y1={423.66}
            x2={245.59}
            y2={423.66}
            gradientTransform="matrix(33.8, 0, 0, -33.8, -8002.57, 14694.08)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#21deff" />
            <stop offset={0.04} stopColor="#21deff" />
            <stop offset={0.17} stopColor="#21deff" />
            <stop offset={0.27} stopColor="#21deff" />
            <stop offset={0.34} stopColor="#21deff" />
            <stop offset={0.38} stopColor="#21deff" />
            <stop offset={1} stopColor="#21deff" />
          </linearGradient>
          <mask
            id="mask-19"
            x={2.12}
            y={2.74}
            width={87.36}
            height={86.09}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-11"
                x={266.36}
                y={342.73}
                width={65}
                height={61.13}
                transform="translate(-151.04 211.26) rotate(-31.51)"
              />
            </g>
          </mask>
          <linearGradient
            id="linear-gradient-11"
            x1={244.43}
            y1={424.46}
            x2={245.22}
            y2={424.46}
            gradientTransform="matrix(0, 34.07, 34.07, 0, -14163.93, -7961.16)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#21deff" />
            <stop offset={0.62} stopColor="#21deff" />
            <stop offset={0.66} stopColor="#21deff" />
            <stop offset={0.73} stopColor="#21deff" />
            <stop offset={0.83} stopColor="#21deff" />
            <stop offset={0.96} stopColor="#21deff" />
            <stop offset={1} stopColor="#21deff" />
          </linearGradient>
          <clipPath id="clip-path-23" transform="translate(-253.06 -327.51)">
            <path
              className="cls-34"
              d="M310.71,353.3a13.45,13.45,0,0,0-5.59,1.26,12.37,12.37,0,0,0-4.41,3.7l-3.54,9.52,6.93,13.31,2.36-7.56.23-1.18a36.43,36.43,0,0,1,1.89-5.83,4.38,4.38,0,0,1,1.34-2l.08-.08a1.57,1.57,0,0,1,1.73.23,2.3,2.3,0,0,1,.71.79c.24.31.39.63.63.94a15.23,15.23,0,0,1,1,2A10.46,10.46,0,0,0,315,370a.08.08,0,0,1,.08.08,6.49,6.49,0,0,0,1.89,1.41,4.57,4.57,0,0,0,2.28.55,6.29,6.29,0,0,0,2.13-.39,5,5,0,0,0,1.81-1.18,9.22,9.22,0,0,0,1.18-1.81,7,7,0,0,0,.39-2.13,5.74,5.74,0,0,0-.47-2.28s-2.13-5.51-5.83-8.27A12.57,12.57,0,0,0,310.71,353.3Z"
            />
          </clipPath>
          <mask
            id="mask-20"
            x={38.64}
            y={20.37}
            width={38.48}
            height={38.62}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-12"
                x={294.66}
                y={350.82}
                width={32.57}
                height={32.75}
                transform="matrix(0.98, -0.2, 0.2, 0.98, -67.37, 69.88)"
              />
            </g>
          </mask>
          <linearGradient
            id="linear-gradient-12"
            x1={243.66}
            y1={422.74}
            x2={244.44}
            y2={422.74}
            gradientTransform="matrix(0, -13.95, -13.95, 0, 6207.33, 3774.7)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#44b044" />
            <stop offset={0.11} stopColor="#44b044" />
            <stop offset={0.27} stopColor="#44b044" />
            <stop offset={0.43} stopColor="#44b044" />
            <stop offset={0.58} stopColor="#44b044" />
            <stop offset={0.7} stopColor="#44b044" />
            <stop offset={0.8} stopColor="#44b044" />
            <stop offset={1} stopColor="#44b044" />
          </linearGradient>
          <clipPath id="clip-path-24" transform="translate(-253.06 -327.51)">
            <path
              className="cls-34"
              d="M290,353.3a11.28,11.28,0,0,0-1.41.16,13.33,13.33,0,0,0-8.66,6,4.92,4.92,0,0,1,1.49.63,5.42,5.42,0,0,1,1.58,1.42,7.15,7.15,0,0,1,1,3.62,57.1,57.1,0,0,0,1.58,8.1,26.16,26.16,0,0,1,3.7-8.18,2.18,2.18,0,0,1,.78-.71,1.15,1.15,0,0,1,.55-.16,1.86,1.86,0,0,1,.95.24c.08,0,.08.08.16.08a6.85,6.85,0,0,1,.7.78,21.48,21.48,0,0,1,1.11,2.37c.63,1.73,1.18,3.93,1.18,3.93l1.57,6.3a45,45,0,0,0,2.13,6.38c2.44,5.59,6.14,7.16,6.14,7.16a14,14,0,0,0,5.9,1.57,11.6,11.6,0,0,0,5.67-1.18,15.27,15.27,0,0,0,5-4,27.28,27.28,0,0,0,2.2-3.54,42.62,42.62,0,0,0,3.39-9.14,51.15,51.15,0,0,0,1.26-6c.16-1,.31-2,.39-3a6.76,6.76,0,0,0-.08-2.83c-.07-.16-.07-.32-.15-.48a5.59,5.59,0,0,0-2.44-2.75,4.67,4.67,0,0,0-2.68-.79,6.83,6.83,0,0,0-1.34.16,27.82,27.82,0,0,1,2.6,4.72,5.74,5.74,0,0,1,.47,2.28,7,7,0,0,1-.39,2.13,9.22,9.22,0,0,1-1.18,1.81,4.08,4.08,0,0,1-1.81,1.18,6.29,6.29,0,0,1-2.13.4,4.87,4.87,0,0,1-2.75-.79l-.56,2.12a25.78,25.78,0,0,1-1.73,4.73,17,17,0,0,1-1.41,2.67,3.51,3.51,0,0,1-1.5,1.34,2.16,2.16,0,0,1-.71.08,1.26,1.26,0,0,1-.71-.24,4,4,0,0,1-1-1.26A15.47,15.47,0,0,1,308,379c-.47-1.18-1.26-4.09-1.26-4.09L306,371.8l-.79-3.07-.55-2.05a23.47,23.47,0,0,0-3.47-7.87,13.22,13.22,0,0,0-6.45-4.88,10.78,10.78,0,0,0-3.19-.63Z"
            />
          </clipPath>
          <linearGradient
            id="linear-gradient-13"
            x1={244.43}
            y1={424.05}
            x2={245.21}
            y2={424.05}
            gradientTransform="matrix(0, 62.11, 62.11, 0, -26031.7, -14830.65)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#3066fb" />
            <stop offset={0.38} stopColor="#2f64f7" />
            <stop offset={0.74} stopColor="#2857d9" />
            <stop offset={1} stopColor="#3c7eff" />
          </linearGradient>
          <mask
            id="mask-21"
            x={20.93}
            y={18.53}
            width={60.45}
            height={54.26}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-14"
                x={280.89}
                y={346.16}
                width={46.64}
                height={54.02}
                transform="translate(-110.64 617.51) rotate(-81.31)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-43"
            cx={243.99}
            cy={424.86}
            r={0.79}
            gradientTransform="matrix(-31.53, 0, 0, 20.81, 7999.93, -8457.64)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#1a3d9c" />
            <stop offset={0.4} stopColor="#1a3d9c" />
            <stop offset={0.7} stopColor="#1a3d9c" />
            <stop offset={1} stopColor="#1a3d9c" />
          </radialGradient>
          <mask
            id="mask-22"
            x={20.92}
            y={18.53}
            width={60.45}
            height={54.27}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-15"
                x={280.89}
                y={346.16}
                width={46.64}
                height={54.02}
                transform="translate(-110.64 617.51) rotate(-81.31)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-44"
            cx={246.84}
            cy={422.85}
            r={0.79}
            gradientTransform="matrix(-3878.79, -0.02, -0.01, 2091.41, 998595.07, -874957.05)"
            xlinkHref="#radial-gradient-43"
          />
          <mask
            id="mask-23"
            x={20.97}
            y={18.59}
            width={60.35}
            height={54.15}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-16"
                x={280.92}
                y={346.19}
                width={46.58}
                height={53.98}
                transform="translate(-110.33 618.06) rotate(-81.39)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-45"
            cx={246.41}
            cy={423}
            r={0.79}
            gradientTransform="matrix(-4619.43, -0.07, -0.03, 1908.39, 1179713.45, -799705.19)"
            xlinkHref="#radial-gradient-43"
          />
          <mask
            id="mask-24"
            x={22.11}
            y={19.98}
            width={58.07}
            height={51.36}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-17"
                x={277.71}
                y={350.52}
                width={53}
                height={45.31}
                transform="translate(-42.69 39.32) rotate(-6.91)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-46"
            cx={244.17}
            cy={424.94}
            r={0.79}
            gradientTransform="matrix(0, 27.56, 19.23, 0, -7859.39, -6357.41)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#1a3d9c" />
            <stop offset={0.16} stopColor="#1a3d9c" />
            <stop offset={0.33} stopColor="#1a3d9c" />
            <stop offset={0.49} stopColor="#1a3d9c" />
            <stop offset={0.61} stopColor="#1a3d9c" />
            <stop offset={0.7} stopColor="#1a3d9c" />
            <stop offset={1} stopColor="#1a3d9c" />
          </radialGradient>
          <mask
            id="mask-25"
            x={16.71}
            y={13.38}
            width={68.88}
            height={64.57}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-18"
                x={275.53}
                y={347.57}
                width={57.37}
                height={51.2}
                transform="translate(-87.98 93.91) rotate(-15.36)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-47"
            cx={244.23}
            cy={424.91}
            r={0.79}
            gradientTransform="matrix(0, 26.49, 18.01, 0, -7337.8, -6091.47)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#18388f" />
            <stop offset={0.37} stopColor="#193b96" />
            <stop offset={0.7} stopColor="#1a3d9c" />
            <stop offset={1} stopColor="#1a3d9c" />
          </radialGradient>
          <radialGradient
            id="radial-gradient-48"
            cx={244.4}
            cy={425.48}
            r={0.79}
            gradientTransform="matrix(0, 12.31, 11.7, 0, -4666.18, -2627.61)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#18388f" />
            <stop offset={0.09} stopColor="#183992" />
            <stop offset={0.22} stopColor="#193b96" />
            <stop offset={0.35} stopColor="#193c98" />
            <stop offset={0.47} stopColor="#1a3c9a" />
            <stop offset={0.59} stopColor="#1a3d9c" />
            <stop offset={0.7} stopColor="#1a3d9c" />
            <stop offset={1} stopColor="#1a3d9c" />
          </radialGradient>
          <radialGradient
            id="radial-gradient-49"
            cx={244.36}
            cy={425.49}
            r={0.79}
            gradientTransform="matrix(0, 12.31, 11.7, 0, -4666.45, -2625.5)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#1a3d9c" />
            <stop offset={0.01} stopColor="#1a3d9c" />
            <stop offset={0.24} stopColor="#1a3d9c" />
            <stop offset={0.44} stopColor="#1a3d9c" />
            <stop offset={0.6} stopColor="#1a3d9c" />
            <stop offset={0.7} stopColor="#1a3d9c" />
            <stop offset={1} stopColor="#1a3d9c" />
          </radialGradient>
          <mask
            id="mask-28"
            x={12.58}
            y={8.33}
            width={77.14}
            height={74.66}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-21"
                x={274.1}
                y={345.4}
                width={60.24}
                height={55.56}
                transform="translate(-121.52 148.33) rotate(-22.97)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-50"
            cx={244.37}
            cy={425.13}
            r={0.79}
            gradientTransform="matrix(0, 29.39, 19.5, 0, -8000.95, -6811.85)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#1a3d9c" />
            <stop offset={0.4} stopColor="#1a3d9c" />
            <stop offset={0.48} stopColor="#1a3d9c" />
            <stop offset={0.69} stopColor="#1a3d9c" />
            <stop offset={0.79} stopColor="#1a3d9c" />
            <stop offset={1} stopColor="#1a3d9c" />
          </radialGradient>
          <mask
            id="mask-29"
            x={17.59}
            y={14.46}
            width={67.11}
            height={62.4}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-22"
                x={275.86}
                y={348.05}
                width={56.7}
                height={50.26}
                transform="translate(-80.72 83.99) rotate(-13.9)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-51"
            cx={244.39}
            cy={425.63}
            r={0.79}
            gradientTransform="matrix(0, 21.8, 14.39, 0, -5835.87, -4960.87)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#1a3d9c" />
            <stop offset={0.06} stopColor="#1a3d9c" />
            <stop offset={0.21} stopColor="#1a3d9c" />
            <stop offset={0.36} stopColor="#1a3d9c" />
            <stop offset={0.51} stopColor="#1a3d9c" />
            <stop offset={0.67} stopColor="#1a3d9c" />
            <stop offset={0.83} stopColor="#1a3d9c" />
            <stop offset={1} stopColor="#1a3d9c" />
          </radialGradient>
          <radialGradient
            id="radial-gradient-52"
            cx={244.39}
            cy={425.63}
            r={0.79}
            gradientTransform="matrix(0, 21.8, 14.39, 0, -5835.87, -4960.87)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#1b3e9e" />
            <stop offset={0.06} stopColor="#1b3e9e" />
            <stop offset={0.21} stopColor="#1b3e9d" />
            <stop offset={0.36} stopColor="#1a3d9d" />
            <stop offset={0.52} stopColor="#1a3d9c" />
            <stop offset={0.67} stopColor="#1a3d9c" />
            <stop offset={0.83} stopColor="#1a3d9c" />
            <stop offset={1} stopColor="#1a3d9c" />
          </radialGradient>
          <mask
            id="mask-31"
            x={17.59}
            y={14.46}
            width={67.11}
            height={62.4}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-25"
                x={275.86}
                y={348.05}
                width={56.7}
                height={50.26}
                transform="translate(-80.72 83.99) rotate(-13.9)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-53"
            cx={244.54}
            cy={426.11}
            r={0.79}
            gradientTransform="matrix(0, 16.68, 11.01, 0, -4400.88, -3713.01)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#183991" />
            <stop offset={0.03} stopColor="#183992" />
            <stop offset={0.18} stopColor="#193a95" />
            <stop offset={0.34} stopColor="#193b97" />
            <stop offset={0.5} stopColor="#1a3c99" />
            <stop offset={0.66} stopColor="#1a3d9b" />
            <stop offset={0.82} stopColor="#1a3d9c" />
            <stop offset={1} stopColor="#1a3d9c" />
          </radialGradient>
          <mask
            id="mask-32"
            x={24.88}
            y={23.36}
            width={52.54}
            height={44.6}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-26"
                x={278.97}
                y={352.11}
                width={50.5}
                height={42.13}
                transform="translate(-18.26 15.66) rotate(-2.86)"
              />
            </g>
          </mask>
          <radialGradient
            id="radial-gradient-54"
            cx={244.3}
            cy={426.06}
            r={0.79}
            gradientTransform="matrix(0, 13.18, 11.6, 0, -4651.03, -2850.12)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#2453d6" />
            <stop offset={0.04} stopColor="#2453d6" />
            <stop offset={0.2} stopColor="#2453d6" />
            <stop offset={0.52} stopColor="#2453d6" />
            <stop offset={0.73} stopColor="#2453d6" />
            <stop offset={1} stopColor="#2453d6" />
          </radialGradient>
          <mask
            id="mask-33"
            x={13.04}
            y={8.9}
            width={76.21}
            height={73.53}
            maskUnits="userSpaceOnUse"
          >
            <g transform="translate(-253.06 -327.51)">
              <rect
                className="cls-27"
                x={276.68}
                y={343.21}
                width={55.07}
                height={59.94}
                transform="translate(-155.81 515.23) rotate(-67.97)"
              />
            </g>
          </mask>
          <linearGradient
            id="linear-gradient-14"
            x1={244.04}
            y1={424.59}
            x2={244.83}
            y2={424.59}
            gradientTransform="matrix(-39.71, 0, 0, 39.71, 10023.19, -16486.77)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#3774ff" />
            <stop offset={0.05} stopColor="#3774ff" />
            <stop offset={0.16} stopColor="#3774ff" />
            <stop offset={0.32} stopColor="#3774ff" />
            <stop offset={0.43} stopColor="#3774ff" />
            <stop offset={1} stopColor="#3774ff" />
          </linearGradient>
          <g className="cls-35">
            <polygon points="125.5 36.8 131.41 36.8 122.83 62.63 116.06 62.63 109.68 43.18 103.3 62.7 96.69 62.7 88.11 36.8 94.09 36.8 100.23 56.48 106.53 36.8 112.91 36.8 119.36 56.56 125.5 36.8" />
            <g className="cls-36">
              <path
                d="M409.66,379.36H390.61a9,9,0,0,0,1.42,3.7,7.18,7.18,0,0,0,2.68,2.2,8.82,8.82,0,0,0,3.46.71,11.3,11.3,0,0,0,3.94-.71,12,12,0,0,0,3.54-2.05l2.83,4A13,13,0,0,1,403.6,390a20.37,20.37,0,0,1-5.74.87A14,14,0,0,1,391,389.2a11.47,11.47,0,0,1-4.65-4.81,16.21,16.21,0,0,1,0-14.25,12.24,12.24,0,0,1,4.57-4.8,13.25,13.25,0,0,1,6.69-1.73,11.59,11.59,0,0,1,10.71,6.53,15.85,15.85,0,0,1,1.57,7.09,13.15,13.15,0,0,0-.24,2.13M404,375a8.11,8.11,0,0,0-2.21-4.73,5.94,5.94,0,0,0-4.33-1.65,6.28,6.28,0,0,0-4.64,1.73,8.11,8.11,0,0,0-2.21,4.65Z"
                transform="translate(-253.06 -327.51)"
              />
              <path
                d="M433.75,365.42a12.61,12.61,0,0,1,4.65,4.88,15,15,0,0,1,0,14,12.64,12.64,0,0,1-4.65,4.89,12,12,0,0,1-6.53,1.73,11.69,11.69,0,0,1-4.65-.95,9.89,9.89,0,0,1-3.46-2.75v3.07h-5.67V353.38h5.67v14.09a9.92,9.92,0,0,1,3.46-2.76,9.64,9.64,0,0,1,4.65-.94,11.88,11.88,0,0,1,6.53,1.65m-3.07,19.05a7.25,7.25,0,0,0,2.76-3,9.75,9.75,0,0,0,.94-4.17,9.5,9.5,0,0,0-.94-4.17,7.27,7.27,0,0,0-2.76-3,8.15,8.15,0,0,0-8.18,0,7.21,7.21,0,0,0-2.76,3,8.79,8.79,0,0,0-.94,4.25,9.87,9.87,0,0,0,.94,4.25,7.18,7.18,0,0,0,2.76,3,8.13,8.13,0,0,0,4.09,1.1,10.77,10.77,0,0,0,4.09-1.26"
                transform="translate(-253.06 -327.51)"
              />
              <path
                d="M468.08,379.36H449a8.8,8.8,0,0,0,1.41,3.7,7.26,7.26,0,0,0,2.68,2.2,8.82,8.82,0,0,0,3.46.71,11.3,11.3,0,0,0,3.94-.71,12,12,0,0,0,3.54-2.05l2.84,4A13,13,0,0,1,462,390a20.26,20.26,0,0,1-5.74.87,14,14,0,0,1-6.85-1.65,11.47,11.47,0,0,1-4.65-4.81,16.21,16.21,0,0,1,0-14.25,12.24,12.24,0,0,1,4.57-4.8,13.27,13.27,0,0,1,6.69-1.73,11.59,11.59,0,0,1,10.71,6.53,15.85,15.85,0,0,1,1.57,7.09c-.08.55-.15,1.26-.23,2.13M462.41,375a8,8,0,0,0-2.21-4.73,6,6,0,0,0-4.4-1.65,6.31,6.31,0,0,0-4.65,1.73A7.81,7.81,0,0,0,449,375Z"
                transform="translate(-253.06 -327.51)"
              />
              <polygon points="241.94 62.7 235.01 62.7 228.47 53.73 222.02 62.7 215.41 62.7 225.17 49.48 215.49 36.8 222.41 36.8 228.71 45.46 235.01 36.8 241.7 36.8 232.17 49.4 241.94 62.7" />
              <path
                d="M427.06,411.55h-1.18V401.16h1.42v3.94a3,3,0,0,1,2.52-1.26,4.62,4.62,0,0,1,1.41.23,3.1,3.1,0,0,1,1.11.87,4.4,4.4,0,0,1,.78,2.76,4.47,4.47,0,0,1-1.1,3.14,3.1,3.1,0,0,1-1.1.71,3.52,3.52,0,0,1-1.26.24,3.06,3.06,0,0,1-1.42-.32,4.2,4.2,0,0,1-1.1-.94Zm4.65-3.85a2.4,2.4,0,0,0-1.42-2.6,2.78,2.78,0,0,0-.79-.16,3.86,3.86,0,0,0-.94.16,1.69,1.69,0,0,0-.71.55,2.91,2.91,0,0,0-.55,2,3.05,3.05,0,0,0,.71,2.2,1.37,1.37,0,0,0,.7.47,2.87,2.87,0,0,0,.87.16,3.94,3.94,0,0,0,.95-.16,1.31,1.31,0,0,0,.7-.63,2.92,2.92,0,0,0,.48-2"
                transform="translate(-253.06 -327.51)"
              />
              <path
                d="M440.6,404.07l-2.6,7.64a5.29,5.29,0,0,1-1,2.05,1.26,1.26,0,0,1-.63.47,2.78,2.78,0,0,1-.79.16,2.74,2.74,0,0,1-.86-.16v-1.1a2.13,2.13,0,0,0,.71.08.7.7,0,0,0,.39-.08.92.92,0,0,0,.31-.24,6.12,6.12,0,0,0,.63-1.34h-.47L433.52,404H435l2.13,6.37,2.12-6.37Z"
                transform="translate(-253.06 -327.51)"
              />
              <rect x={203.99} y={73.65} width={2.6} height={10.47} />
              <path
                d="M480.91,404.15a4.42,4.42,0,0,0-2.21-.55,2.73,2.73,0,0,0-2.91,2.76,2.69,2.69,0,0,0,2.91,2.75,4.32,4.32,0,0,0,2.21-.55v2.84a8.51,8.51,0,0,1-2.36.39,5.43,5.43,0,1,1,0-10.86,7.73,7.73,0,0,1,2.36.39Z"
                transform="translate(-253.06 -327.51)"
              />
              <path
                d="M453.43,404.15a4.36,4.36,0,0,0-2.2-.55,2.73,2.73,0,0,0-2.91,2.76,2.69,2.69,0,0,0,2.91,2.75,4.26,4.26,0,0,0,2.2-.55v2.84a8.48,8.48,0,0,1-2.44.39,5.43,5.43,0,1,1,0-10.86,8.58,8.58,0,0,1,2.44.39Z"
                transform="translate(-253.06 -327.51)"
              />
              <path
                d="M489.17,403.68a2.16,2.16,0,0,0-1,.24,2.09,2.09,0,0,0-.86.63,2,2,0,0,0-.56.86,1.63,1.63,0,0,0-.15,1,4.47,4.47,0,0,0,.15,1,3.41,3.41,0,0,0,.56.87,3.67,3.67,0,0,0,.86.63,2.55,2.55,0,0,0,1,.23,2.59,2.59,0,0,0,1.89-.86,2,2,0,0,0,.55-.87,1.55,1.55,0,0,0,.16-1,4,4,0,0,0-.16-1,2.94,2.94,0,0,0-.55-.86,3.18,3.18,0,0,0-.86-.63,1.53,1.53,0,0,0-1-.24m5.52,2.68a5.52,5.52,0,1,1-5.52-5.43,5.45,5.45,0,0,1,5.52,5.43"
                transform="translate(-253.06 -327.51)"
              />
              <path
                d="M469.65,403.52a9.69,9.69,0,0,0-2-.31c-1,0-1.65.31-1.65.86s.79.87,1.18,1l.71.23a3.19,3.19,0,0,1,2.52,3c0,2.59-2.28,3.46-4.33,3.46a11.38,11.38,0,0,1-2.83-.32V409a8.67,8.67,0,0,0,2.51.4c1.34,0,1.89-.4,1.89-.95s-.55-.86-1.18-1l-.55-.16c-1.41-.47-2.67-1.34-2.67-3.07,0-2,1.41-3.23,3.85-3.23a14.32,14.32,0,0,1,2.6.32Z"
                transform="translate(-253.06 -327.51)"
              />
            </g>
            <g className="cls-37">
              <rect
                className="cls-38"
                x={267.39}
                y={345.06}
                width={62.94}
                height={56.46}
                transform="translate(-371.18 -188.31) rotate(-22.01)"
              />
            </g>
            <g className="cls-37">
              <g className="cls-39">
                <rect
                  className="cls-40"
                  x={268.56}
                  y={347.05}
                  width={60.6}
                  height={52.48}
                  transform="translate(-342.83 -232.85) rotate(-15.68)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-41">
                <rect
                  className="cls-42"
                  x={278.35}
                  y={347.04}
                  width={41.02}
                  height={52.51}
                  transform="translate(-333.4 337.11) rotate(-88.85)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-43">
                <rect
                  className="cls-44"
                  x={272.52}
                  y={352.67}
                  width={52.68}
                  height={41.24}
                  transform="translate(-262.1 -320.1) rotate(-1.4)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-43">
                <rect
                  className="cls-45"
                  x={272.52}
                  y={352.67}
                  width={52.68}
                  height={41.24}
                  transform="translate(-262.1 -320.1) rotate(-1.4)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-43">
                <rect
                  className="cls-46"
                  x={272.52}
                  y={352.67}
                  width={52.68}
                  height={41.24}
                  transform="translate(-262.1 -320.1) rotate(-1.4)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-47">
                <rect
                  className="cls-48"
                  x={270.13}
                  y={341.56}
                  width={57.46}
                  height={63.46}
                  transform="translate(-416.36 168.58) rotate(-66.2)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-49">
                <rect
                  className="cls-50"
                  x={267.6}
                  y={340.63}
                  width={62.52}
                  height={65.32}
                  transform="translate(-431.55 74.21) rotate(-54.73)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-51">
                <rect
                  className="cls-52"
                  x={267.6}
                  y={340.64}
                  width={62.52}
                  height={65.32}
                  transform="translate(-431.55 74.22) rotate(-54.73)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-53">
                <rect
                  className="cls-54"
                  x={274.31}
                  y={344.1}
                  width={49.1}
                  height={58.39}
                  transform="translate(-377.56 268.13) rotate(-79.03)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-55">
                <rect
                  className="cls-56"
                  x={267.02}
                  y={340.61}
                  width={63.68}
                  height={65.36}
                  transform="translate(-432.38 41.61) rotate(-50.82)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-57">
                <rect
                  className="cls-58"
                  x={266.35}
                  y={342.7}
                  width={65.01}
                  height={61.19}
                  transform="translate(-404.52 -115.1) rotate(-31.66)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-59">
                <rect
                  className="cls-60"
                  x={266.21}
                  y={341.29}
                  width={65.3}
                  height={64.01}
                  transform="translate(-423.95 -43.66) rotate(-40.54)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-61">
                <rect
                  className="cls-62"
                  x={275.91}
                  y={345.22}
                  width={45.91}
                  height={56.15}
                  transform="translate(-360.65 297.7) rotate(-83.11)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-63">
                <rect
                  className="cls-64"
                  x={266.52}
                  y={343.2}
                  width={64.68}
                  height={60.2}
                  transform="translate(-397.58 -133.34) rotate(-29.32)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-65">
                <rect
                  className="cls-66"
                  x={267.82}
                  y={340.67}
                  width={62.08}
                  height={65.24}
                  transform="translate(-430.8 84.74) rotate(-55.99)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-67">
                <rect
                  className="cls-68"
                  x={266.62}
                  y={340.73}
                  width={64.48}
                  height={65.12}
                  transform="translate(-431.17 11.59) rotate(-47.22)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-69">
                <rect
                  className="cls-70"
                  x={268.53}
                  y={347}
                  width={60.67}
                  height={52.58}
                  transform="translate(-343.55 -231.84) rotate(-15.83)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-71">
                <rect
                  className="cls-72"
                  x={267.79}
                  y={345.78}
                  width={62.15}
                  height={55.04}
                  transform="translate(-361.05 -205.5) rotate(-19.62)"
                />
              </g>
            </g>
            <g className="cls-37">
              <g className="cls-73">
                <rect
                  className="cls-74"
                  x={266.36}
                  y={342.73}
                  width={65}
                  height={61.13}
                  transform="translate(-404.11 -116.25) rotate(-31.51)"
                />
              </g>
            </g>
            <g className="cls-75">
              <g className="cls-76">
                <rect
                  className="cls-77"
                  x={294.66}
                  y={350.82}
                  width={32.57}
                  height={32.75}
                  transform="matrix(0.98, -0.2, 0.2, 0.98, -320.43, -257.64)"
                />
              </g>
            </g>
            <g className="cls-78">
              <rect
                className="cls-79"
                x={277.71}
                y={343.87}
                width={53.01}
                height={58.61}
                transform="translate(-398.73 217.18) rotate(-71.68)"
              />
            </g>
            <g className="cls-78">
              <g className="cls-80">
                <rect
                  className="cls-81"
                  x={280.89}
                  y={346.16}
                  width={46.64}
                  height={54.02}
                  transform="translate(-363.71 290) rotate(-81.31)"
                />
              </g>
            </g>
            <g className="cls-78">
              <g className="cls-82">
                <rect
                  className="cls-83"
                  x={280.89}
                  y={346.17}
                  width={46.64}
                  height={54.02}
                  transform="translate(-363.71 290) rotate(-81.31)"
                />
              </g>
            </g>
            <g className="cls-78">
              <g className="cls-84">
                <rect
                  className="cls-85"
                  x={280.92}
                  y={346.19}
                  width={46.58}
                  height={53.98}
                  transform="translate(-363.39 290.55) rotate(-81.39)"
                />
              </g>
            </g>
            <g className="cls-78">
              <g className="cls-86">
                <rect
                  className="cls-87"
                  x={277.71}
                  y={350.52}
                  width={53}
                  height={45.31}
                  transform="translate(-295.76 -288.2) rotate(-6.91)"
                />
              </g>
            </g>
            <g className="cls-78">
              <g className="cls-88">
                <rect
                  className="cls-89"
                  x={275.53}
                  y={347.57}
                  width={57.37}
                  height={51.2}
                  transform="translate(-341.05 -233.6) rotate(-15.36)"
                />
              </g>
            </g>
            <g className="cls-78">
              <g className="cls-88">
                <rect
                  className="cls-90"
                  x={275.53}
                  y={347.57}
                  width={57.37}
                  height={51.2}
                  transform="translate(-341.05 -233.6) rotate(-15.36)"
                />
              </g>
            </g>
            <g className="cls-78">
              <g className="cls-88">
                <rect
                  className="cls-91"
                  x={275.53}
                  y={347.57}
                  width={57.37}
                  height={51.2}
                  transform="translate(-341.05 -233.6) rotate(-15.36)"
                />
              </g>
            </g>
            <g className="cls-78">
              <g className="cls-92">
                <rect
                  className="cls-93"
                  x={274.1}
                  y={345.4}
                  width={60.24}
                  height={55.56}
                  transform="translate(-374.59 -179.19) rotate(-22.97)"
                />
              </g>
            </g>
            <g className="cls-78">
              <g className="cls-94">
                <rect
                  className="cls-95"
                  x={275.86}
                  y={348.05}
                  width={56.7}
                  height={50.26}
                  transform="translate(-333.79 -243.52) rotate(-13.9)"
                />
              </g>
            </g>
            <g className="cls-78">
              <g className="cls-94">
                <rect
                  className="cls-96"
                  x={275.86}
                  y={348.05}
                  width={56.7}
                  height={50.26}
                  transform="translate(-333.79 -243.52) rotate(-13.9)"
                />
              </g>
            </g>
            <g className="cls-78">
              <g className="cls-97">
                <rect
                  className="cls-98"
                  x={275.86}
                  y={348.05}
                  width={56.7}
                  height={50.26}
                  transform="translate(-333.79 -243.53) rotate(-13.9)"
                />
              </g>
            </g>
            <g className="cls-78">
              <g className="cls-99">
                <rect
                  className="cls-100"
                  x={278.97}
                  y={352.11}
                  width={50.5}
                  height={42.13}
                  transform="translate(-271.32 -311.86) rotate(-2.86)"
                />
              </g>
            </g>
            <g className="cls-78">
              <g className="cls-101">
                <rect
                  className="cls-102"
                  x={276.68}
                  y={343.21}
                  width={55.07}
                  height={59.94}
                  transform="translate(-408.88 187.72) rotate(-67.97)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
});

export default WebexWebhookCoverImage;
